import { api } from '../api';

const API_GRAPH_GLOBALS_PATH = '/graph/globals';

export const fetchGraphGlobals = async () => api.get(`${API_GRAPH_GLOBALS_PATH}`);
